import React from 'react';
import ManualTab from './ManualTab';

const ManualCouponLeftTabItem = ({ dataSource, loading }) => {
  return (
    <>
      <ManualTab dataSource={dataSource} loading={loading} />
    </>
  );
};

export default ManualCouponLeftTabItem;
